module.exports = __webpack_public_path__ + "static/greybowbooties-7dc1c0aa90d673ea6574210a4206d572.jpeg";